var map = {
	"./ajio.png": "6828",
	"./amazon.png": "24d9",
	"./amazon_fresh.png": "a86b",
	"./amazon_retail.png": "b8fb",
	"./bbasket.png": "b79d",
	"./bigbasket.png": "6fc9",
	"./blinkit.png": "5f12",
	"./brand/8.png": "fdf8",
	"./brand/Logo-green.png": "4508",
	"./brand/Logo-small-green.png": "c30d",
	"./brand/Logo-small-trans.png": "ad2b",
	"./brand/Logo-small-trans_new.png": "aac9",
	"./brand/Logo-transparent.png": "55da",
	"./brand/Logo-transparent_old.png": "bf04",
	"./brand/brand_logos/Logos-17.png": "9ee1",
	"./brand/brand_logos/Logos-18.png": "2822",
	"./brand/brand_logos/Logos-20.png": "81bc",
	"./brand/brand_logos/Logos-21.png": "de63",
	"./brand/brand_logos/Logos-22.png": "136c",
	"./brand/logo_old.png": "62dd",
	"./croma.png": "56fb",
	"./flipkart.png": "3e42",
	"./flipkart_grocery.png": "7d12",
	"./grofers.png": "f585",
	"./jiomart.png": "de57",
	"./login-page-img.png": "4fc1",
	"./loginPageLeftImg.png": "a895",
	"./logo.png": "c780",
	"./myntra.png": "d031",
	"./paytm.png": "af75",
	"./profile-avatar.png": "afee",
	"./ril.png": "139a",
	"./rr logo.png": "3c7d",
	"./snapdeal.png": "79d2",
	"./sov/acer.png": "0542",
	"./sov/amazon.png": "6520",
	"./sov/asus.png": "a26b",
	"./sov/bb.png": "23d0",
	"./sov/bechtle.png": "cd86",
	"./sov/cdw.png": "188b",
	"./sov/connection.png": "1d4f",
	"./sov/costco.png": "0cfb",
	"./sov/dell.png": "7a48",
	"./sov/dixon.png": "beb2",
	"./sov/fujitsu.png": "a31e",
	"./sov/hn.png": "78d5",
	"./sov/hp.png": "f9d6",
	"./sov/inmac.png": "28b7",
	"./sov/insight.png": "5bc2",
	"./sov/jd.png": "affc",
	"./sov/lenovo.png": "fc6c",
	"./sov/mediamarkt.png": "ab1e",
	"./sov/nec.png": "b1f6",
	"./sov/shi.png": "5c1f",
	"./sov/technoworld.png": "3c14",
	"./sov/walmart.png": "f66a",
	"./swiggy.png": "14bb",
	"./tatacliq.png": "1576",
	"./vijaysales.png": "d15a",
	"./zepto.png": "2897"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09ce";